import React, { useState } from 'react';
import List from './List';
import Form from './Form';
import data from './data';
const App = () => {
  const [people, setPeople] = useState(data);
  const clearPeople = () => {
    setPeople([]);
  };

  return (
    <>
      <div className='container'>
        <h1>{people.length} birthdays today</h1>
        <List people={people} setPeople={setPeople} />
        <input
          type='button'
          className='btn'
          value='Clear all'
          onClick={clearPeople}
        />
      </div>
      <Form people={people} setPeople={setPeople} />
    </>
  );
};

export default App;
